import {useEffect, useState} from 'react'
import {getNgRateTab} from '../../../../services/api/3dApi'

export default (tab, params) => {
    const [state, setState] = useState({data: null, loading: true, error: ''})
    const key = JSON.stringify(params)

    useEffect(() => {
        let cancelled = false
        setState(previous => ({...previous, loading: true, error: ''}))

        getNgRateTab(tab, params)
            .then((response) => {
                if (cancelled) return
                if (!response.success) throw new Error(response.message || response.error || 'Lỗi tải dữ liệu')
                setState({data: response.data, loading: false, error: ''})
            })
            .catch(error => {
                if (!cancelled) setState({data: null, loading: false, error: error.message})
            })

        return () => {
            cancelled = true
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tab, key])

    return state
}
